import styled from 'styled-components';

import {textSizes} from '@stencil/build-theme';

export const FeatureItem = styled.li`
  padding: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 0.8rem;
  ${({isListView}) =>
    isListView
      ? `
      li + li {
        border-top: 1px solid #e1e7ee;
        padding-top: 1.2rem;
      }
    `
      : `
      border-radius: 0.8rem;
      border: 1px solid #e1e7ee;
  `}
`;

export const FeatureItemImgWrapper = styled.div`
  border-radius: 0.8rem;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  background: #e8f2ff;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: ${({isListView}) => (isListView ? 'flex-start' : 'center')};
`;

export const FeatureItemImg = styled.img`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: contain;
`;

export const FeatureItemDesc = styled.p`
  ${textSizes.BaseW1};
  color: #717171;
  ${({isListView, numberOfLines}) =>
    isListView
      ? `
      align-self: start;
    `
      : `
      align-self: center;
      display: -webkit-box;
      -webkit-line-clamp:${numberOfLines || 2};
      -webkit-box-orient: vertical;
      overflow: hidden;
  `}
`;
